export default "__VITE_ASSET__CVSNb4p0__"